import request from '../utils/request'
import board from '../utils/board'

export function listTrain(data) {
    return request({
        url: '/api/open/uni/listTrain?pageSize='+data.pageSize+'&pageNum='+data.pageNum+'&keywords='+data.keywords+'&cate_ids='+data.cate_ids,
        method: 'get'
    })
}

export function menuList(data){
    return request({
        url: '/api/open/uni/listcate?pageNum='+ data.pageNum +"&pageSize="+ data.pageSize +"&parent_cate_value="+ data.parent_cate_value,
        method: 'get'
    })
}

export function trainInfo(data){
    return request({
        url: '/api/open/uni/trainInfo?id='+data.id,
        method: 'get'
    })
}

export function add(data){
    return request({
        url: '/api/booking/add',
        method: 'post',
        data
    })
}

export function policy(data){
    return request({
        url: '/api/oss/policy',
        method: 'post',
        data
    })
}

export function filex(data){
    return request({
        url: '/api/upload/filex',
        method: 'post',
        data,
        headers: {
            token: localStorage.getItem('token')
        }
    })
}

export function aliyuncs(data){
    return board({
        url: '/board',
        method: 'post',
        data,
        headers: {
            "Content-Type": 'multipart/form-data'
        }
    })
}

